// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfig, ToolConfigDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpsertPhoneNumberToolConfig(): (
  phoneNumberId: string,
  toolId: string,
  key: string,
  requestBody: ToolConfigDaten
) => Promise<ToolConfig> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId, toolId, key, requestBody) =>
      (await getAPI()).phonenumbers.upsertPhoneNumberToolConfig({
        phoneNumberId,
        toolId,
        key,
        requestBody,
      }),
    [getAPI]
  );
}
